/** A count-up timer for the exam item player — starts at 0:00 and ticks
 * every second while `running`. Isolated so it can be unit-tested with
 * fake timers without the player's async item load. */
import { useEffect, useState } from "react";

export function Stopwatch({ running }: { running: boolean }) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!running) return;
    const id = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(id);
  }, [running]);

  const mm = Math.floor(seconds / 60);
  const ss = String(seconds % 60).padStart(2, "0");
  return (
    <span aria-label="elapsed time" className="font-mono text-sm text-muted">
      ⏱ {mm}:{ss}
    </span>
  );
}
